import styled from "styled-components";

export const Container = styled.div`
  color: #000;
  background-color: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 85vh;
  width: 100%;
  background-repeat: no-repeat;
  position: relative;
`;
